// import { useState, useEffect, useRef, useCallback } from 'react';

// /**
//  * HaivisionStatsTab
//  * Shows a network topology diagram — caller boxes (yellow) connected
//  * by dashed lines to the destination box (cyan) — matching the
//  * Haivision Gateway UI style.
//  * Click a caller box to expand its stats below the diagram.
//  */

// const REFRESH_OPTIONS = [2, 5, 10];
// const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

// function apiHeaders() {
//   const token = sessionStorage.getItem('srt.auth.token');
//   return {
//     'Content-Type': 'application/json',
//     ...(token ? { Authorization: `Bearer ${token}` } : {}),
//   };
// }

// // ── Topology SVG ──────────────────────────────────────────────────────────────
// // Yellow destination box at TOP, cyan caller boxes at BOTTOM.
// // Animated yellow dots travel from yellow → cyan along bezier curves.
// // Dashed lines flow downward using stroke-dashoffset animation.
// function TopologyDiagram({ connections, destAddress, destName, selectedIdx, onSelect }) {
//   const BOX_W    = 170;
//   const BOX_H    = 64;
//   const GAP      = 16;
//   const DEST_W   = 280;
//   const DEST_H   = 68;
//   const PAD_X    = 24;
//   const TOP_Y    = 20;
//   const BOTTOM_Y = 200;

//   const n        = Math.max(connections.length, 1);
//   const rowW     = n * BOX_W + (n - 1) * GAP;
//   const svgW     = Math.max(rowW + PAD_X * 2, DEST_W + PAD_X * 2);
//   const CALLER_Y = BOTTOM_Y;
//   const DEST_TOP = TOP_Y;
//   const svgH     = CALLER_Y + BOX_H + 40;

//   const startX = (svgW - rowW) / 2;
//   const destX  = (svgW - DEST_W) / 2;
//   const destCX = svgW / 2;
//   const destBY = DEST_TOP + DEST_H;   // bottom center of yellow box
//   const CTRL_Y = (destBY + CALLER_Y) / 2; // bezier control point Y

//   return (
//     <>
//       {/* Keyframe animations */}
//       <style>{`
//         @keyframes dash-flow { to { stroke-dashoffset: -40; } }
//         @keyframes dest-pulse {
//           0%,100% { opacity: 0.2; r: 46; }
//           50%      { opacity: 0.05; r: 56; }
//         }
//       `}</style>

//       <svg
//         viewBox={`0 0 ${svgW} ${svgH}`}
//         style={{ width: '100%', display: 'block', margin: '0 auto', overflow: 'visible' }}
//       >
//         <defs>
//           {/* Glow filter for animated dots */}
//           <filter id="glow-ylw" x="-50%" y="-50%" width="200%" height="200%">
//             <feGaussianBlur stdDeviation="2.5" result="blur" />
//             <feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge>
//           </filter>
//           <filter id="glow-cyn" x="-50%" y="-50%" width="200%" height="200%">
//             <feGaussianBlur stdDeviation="2" result="blur" />
//             <feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge>
//           </filter>
//         </defs>

//         {/* Pulsing ring on destination */}
//         <circle cx={destCX} cy={DEST_TOP + DEST_H / 2} r={46}
//           fill="none" stroke="#eab308" strokeWidth="1"
//           style={{ animation: 'dest-pulse 3s ease-in-out infinite' }} />

//         {/* Destination box — YELLOW — at TOP */}
//         <rect x={destX} y={DEST_TOP} width={DEST_W} height={DEST_H} rx={8}
//           fill="rgba(234,179,8,0.12)" stroke="#eab308" strokeWidth="1.5" />
//         <circle cx={destX + 14} cy={DEST_TOP + 22} r={5} fill="#10b981" />
//         <text x={destX + 28} y={DEST_TOP + 25}
//           fontSize="12" fontWeight="700" fill="#fde047" fontFamily="Arial, sans-serif">
//           {destName.length > 28 ? destName.slice(0, 28) + '…' : destName}
//         </text>
//         <text x={destX + 14} y={DEST_TOP + 50}
//           fontSize="10" fill="#ca8a04" fontFamily="'Courier New', monospace">
//           {`SRT | ${destAddress} (${connections.length} CLIENT${connections.length !== 1 ? 'S' : ''})`}
//         </text>

//         {/* Animated connection lines + packet dots */}
//         {connections.map((conn, i) => {
//           const callerCX = startX + i * (BOX_W + GAP) + BOX_W / 2;
//           const callerTY = CALLER_Y;
//           const cpX      = (destCX + callerCX) / 2;
//           // Bezier path from yellow bottom → down → cyan top
//           const pathD = `M ${destCX} ${destBY} Q ${cpX} ${CTRL_Y} ${callerCX} ${callerTY}`;
//           const isSelected = selectedIdx === i;
//           const delay0 = (i * 0.4) % 2.2;
//           const delay1 = (i * 0.4 + 0.7) % 2.2;
//           const delay2 = (i * 0.4 + 1.4) % 2.2;

//           return (
//             <g key={`conn-${i}`}>
//               {/* Flowing dashed line */}
//               <path d={pathD} fill="none"
//                 stroke={isSelected ? '#22d3ee' : 'rgba(6,182,212,0.35)'}
//                 strokeWidth={isSelected ? 2 : 1.5}
//                 strokeDasharray="8 6"
//                 style={{
//                   animation: `dash-flow ${isSelected ? 0.6 : 0.8}s linear infinite`,
//                   opacity: isSelected ? 0.9 : 0.5,
//                   transition: 'opacity 0.2s, stroke-width 0.2s',
//                 }}
//               />
//               {/* Packet dot 1 */}
//               <circle r="3.5" fill="#eab308" filter="url(#glow-ylw)"
//                 style={{ opacity: isSelected ? 1 : 0.7 }}>
//                 <animateMotion dur="1.8s" repeatCount="indefinite" begin={`${delay0}s`}
//                   path={pathD} />
//               </circle>
//               {/* Packet dot 2 */}
//               <circle r="3.5" fill="#eab308" filter="url(#glow-ylw)"
//                 style={{ opacity: isSelected ? 1 : 0.7 }}>
//                 <animateMotion dur="1.8s" repeatCount="indefinite" begin={`${delay1}s`}
//                   path={pathD} />
//               </circle>
//               {/* Packet dot 3 */}
//               <circle r="3" fill="#fbbf24" filter="url(#glow-ylw)"
//                 style={{ opacity: isSelected ? 0.8 : 0.5 }}>
//                 <animateMotion dur="1.8s" repeatCount="indefinite" begin={`${delay2}s`}
//                   path={pathD} />
//               </circle>
//             </g>
//           );
//         })}

//         {/* No connections placeholder */}
//         {connections.length === 0 && (
//           <text x={svgW / 2} y={CALLER_Y + BOX_H / 2 + 4}
//             textAnchor="middle" fontSize="12" fill="#6b7280" fontFamily="Arial, sans-serif">
//             No active connections
//           </text>
//         )}

//         {/* Caller boxes — CYAN — at BOTTOM */}
//         {connections.map((conn, i) => {
//           const x        = startX + i * (BOX_W + GAP);
//           const selected = selectedIdx === i;
//           const isConn   = conn.state === 'connected' || conn.state === 'Connected';
//           const ipLabel  = conn.port && conn.port !== '—'
//             ? `${conn.address}:${conn.port}`
//             : conn.address;
//           return (
//             <g key={`caller-${i}`} onClick={() => onSelect(i)} style={{ cursor: 'pointer' }}>
//               {/* Selection glow */}
//               {selected && (
//                 <rect x={x - 3} y={CALLER_Y - 3} width={BOX_W + 6} height={BOX_H + 6} rx={10}
//                   fill="none" stroke="#22d3ee" strokeWidth="1" opacity="0.3" />
//               )}
//               <rect x={x} y={CALLER_Y} width={BOX_W} height={BOX_H} rx={7}
//                 fill={selected ? 'rgba(6,182,212,0.18)' : 'rgba(6,182,212,0.06)'}
//                 stroke={selected ? '#22d3ee' : '#0e7490'}
//                 strokeWidth={selected ? 2 : 1.5}
//               />
//               <circle cx={x + 14} cy={CALLER_Y + 22} r={5}
//                 fill={isConn ? '#10b981' : '#ef4444'}
//                 filter={isConn ? 'url(#glow-cyn)' : 'none'} />
//               <text x={x + 26} y={CALLER_Y + 25}
//                 fontSize="11" fontWeight="700" fill="#22d3ee" fontFamily="Arial, sans-serif">
//                 {`CLIENT ${i + 1}`}
//               </text>
//               <text x={x + 12} y={CALLER_Y + 45}
//                 fontSize="10" fill="#0891b2" fontFamily="'Courier New', monospace">
//                 {ipLabel.length > 22 ? ipLabel.slice(0, 22) + '…' : ipLabel}
//               </text>
//               {conn.bitrate > 0 && (
//                 <text x={x + BOX_W - 10} y={CALLER_Y + BOX_H - 10}
//                   fontSize="9" fill="#155e75" textAnchor="end" fontFamily="monospace">
//                   {(conn.bitrate / 1000).toFixed(2)} Mbps
//                 </text>
//               )}
//             </g>
//           );
//         })}
//       </svg>
//     </>
//   );
// }

// // ── Stat cell ─────────────────────────────────────────────────────────────────
// function StatCell({ label, value, color }) {
//   return (
//     <div style={{ padding: '8px 12px', background: 'rgba(255,255,255,0.04)', borderRadius: 6 }}>
//       <div style={{ fontSize: 9, color: '#6b7280', marginBottom: 3, letterSpacing: '0.04em' }}>
//         {label}
//       </div>
//       <div style={{ fontSize: 13, fontFamily: 'monospace', color: color ?? '#e5e7eb', fontWeight: 600 }}>
//         {value ?? '—'}
//       </div>
//     </div>
//   );
// }

// // ─────────────────────────────────────────────────────────────────────────────
// // Main
// // ─────────────────────────────────────────────────────────────────────────────
// export default function HaivisionStatsTab({ channel }) {
//   const [refreshSec,  setRefreshSec]  = useState(2);
//   const [routeId,     setRouteId]     = useState(null);
//   const [routeName,   setRouteName]   = useState(null);
//   const [connections, setConnections] = useState([]);
//   const [routeState,  setRouteState]  = useState(null);
//   const [selectedIdx, setSelectedIdx] = useState(null);
//   const [destAddr,    setDestAddr]    = useState(null);
//   const [error,       setError]       = useState(null);
//   const [loading,     setLoading]     = useState(true);
//   const timerRef     = useRef(null);
//   const [isFullscreen, setIsFullscreen] = useState(false);

//   // Close fullscreen on Escape key
//   useEffect(() => {
//     const onKey = (e) => { if (e.key === 'Escape' && isFullscreen) setIsFullscreen(false); };
//     document.addEventListener('keydown', onKey);
//     return () => document.removeEventListener('keydown', onKey);
//   }, [isFullscreen]);

//   function toggleFullscreen() {
//     setIsFullscreen(f => !f);
//   }

//   // Step 1: find matching route
//   useEffect(() => {
//     let cancelled = false;
//     async function findRoute() {
//       try {
//         const res = await fetch(`${API_BASE}/haivision/routes`, { headers: apiHeaders() });
//         if (!res.ok) {
//           const text = await res.text();
//           throw new Error(
//             res.status === 502 ? 'Cannot reach Haivision. Check HAIVISION_URL in .env'
//             : res.status === 401 ? 'Not authenticated — open SRT Manager through DR Pulse 360'
//             : `Routes error: ${res.status}`
//           );
//         }
//         const routes = await res.json();
//         if (!Array.isArray(routes) || routes.length === 0) {
//           throw new Error('No routes returned from Haivision');
//         }

//         const cName = (channel.display_name ?? '').toLowerCase();
//         const ip    = channel.channel_ip ?? '';

//         const match = routes.find(r => {
//           const rName = (r.name ?? '').toLowerCase();
//           return rName.includes(cName) || cName.includes(rName)
//             || (ip && JSON.stringify(r).includes(ip));
//         }) ?? routes[0];

//         if (!cancelled) {
//           setRouteId(match.id ?? match.routeId);
//           setRouteName(match.name ?? channel.display_name);
//         }
//       } catch (e) {
//         if (!cancelled) { setError(e.message); setLoading(false); }
//       }
//     }
//     findRoute();
//     return () => { cancelled = true; };
//   }, [channel.channel_ip, channel.display_name]);

//   // Step 2: poll stats
//   const fetchStats = useCallback(async () => {
//     if (!routeId) return;
//     try {
//       const res = await fetch(
//         `${API_BASE}/haivision/routes/${routeId}/stats`,
//         { headers: apiHeaders() }
//       );
//       if (!res.ok) throw new Error(`Stats error: ${res.status}`);
//       const data = await res.json();
//       setConnections(data.connections ?? []);
//       setRouteState(data.state ?? null);
//       if (data.destAddress && data.destAddress !== '—') {
//         setDestAddr(data.destAddress);
//       }
//       setError(null);
//       setLoading(false);
//     } catch (e) {
//       setError(e.message);
//       setLoading(false);
//     }
//   }, [routeId]);

//   useEffect(() => {
//     if (!routeId) return;
//     fetchStats();
//     timerRef.current = setInterval(fetchStats, refreshSec * 1000);
//     return () => clearInterval(timerRef.current);
//   }, [fetchStats, refreshSec, routeId]);

//   const selected = selectedIdx != null ? connections[selectedIdx] : null;
//   const destAddress = destAddr
//     ?? (channel.channel_ip
//       ? `${channel.channel_ip}${channel.source_port ? ':' + channel.source_port : ''}`
//       : '—');

//   return (
//     <div style={{
//       display: 'flex', flexDirection: 'column',
//       background: '#0d1117', color: '#f3f4f6',
//       overflow: 'hidden',
//       ...(isFullscreen ? {
//         position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
//         zIndex: 99999, width: '100vw', height: '100vh', borderRadius: 0,
//       } : {
//         height: '100%', minHeight: 440, borderRadius: '0 0 10px 10px',
//       }),
//     }}>

//       {/* Toolbar */}
//       <div style={{
//         display: 'flex', alignItems: 'center', justifyContent: 'space-between',
//         padding: '8px 16px', background: '#161b22',
//         borderBottom: '1px solid rgba(255,255,255,0.08)', flexShrink: 0,
//       }}>
//         <div style={{ fontSize: 11, fontWeight: 600, color: '#94a3b8' }}>
//           {routeName
//             ? `${connections.length} connection${connections.length !== 1 ? 's' : ''} · ${routeName}`
//             : 'Connecting to Haivision…'}
//           {routeState && (
//             <span style={{
//               marginLeft: 10, fontSize: 9, padding: '2px 7px', borderRadius: 3,
//               background: routeState === 'running' ? 'rgba(16,185,129,0.15)' : 'rgba(100,100,100,0.15)',
//               color: routeState === 'running' ? '#10b981' : '#6b7280',
//             }}>
//               {routeState.toUpperCase()}
//             </span>
//           )}
//         </div>
//         <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
//           <span style={{ fontSize: 9, color: '#6b7280' }}>Refresh</span>
//           <div style={{ display: 'flex', background: '#1f2937', borderRadius: 4, overflow: 'hidden' }}>
//             {REFRESH_OPTIONS.map(s => (
//               <button key={s} onClick={() => setRefreshSec(s)} style={{
//                 padding: '3px 8px', fontSize: 9, border: 'none', cursor: 'pointer',
//                 background: refreshSec === s ? '#4f46e5' : 'transparent',
//                 color: refreshSec === s ? '#fff' : '#9ca3af', fontFamily: 'monospace',
//               }}>{s}s</button>
//             ))}
//           </div>
//           <button
//             onClick={toggleFullscreen}
//             title={isFullscreen ? 'Exit fullscreen' : 'Fullscreen'}
//             style={{
//               background: 'none', border: '1px solid rgba(255,255,255,0.15)',
//               borderRadius: 4, padding: '3px 8px', cursor: 'pointer',
//               color: '#9ca3af', fontSize: 12, lineHeight: 1,
//               display: 'flex', alignItems: 'center', gap: 4,
//             }}
//           >
//             {isFullscreen ? (
//               <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.5">
//                 <path d="M4.5 1.5H2a.5.5 0 0 0-.5.5v2.5M7.5 1.5H10a.5.5 0 0 1 .5.5v2.5M4.5 10.5H2a.5.5 0 0 1-.5-.5V7.5M7.5 10.5H10a.5.5 0 0 0 .5-.5V7.5"/>
//               </svg>
//             ) : (
//               <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.5">
//                 <path d="M1.5 4.5V2a.5.5 0 0 1 .5-.5h2.5M7.5 1.5H10a.5.5 0 0 1 .5.5v2.5M10.5 7.5V10a.5.5 0 0 1-.5.5H7.5M4.5 10.5H2a.5.5 0 0 1-.5-.5V7.5"/>
//               </svg>
//             )}
//           </button>
//         </div>
//       </div>

//       {/* Error */}
//       {error && (
//         <div style={{
//           padding: '10px 16px', background: 'rgba(239,68,68,0.1)',
//           borderBottom: '1px solid rgba(239,68,68,0.2)', fontSize: 11, color: '#f87171', flexShrink: 0,
//         }}>
//           {error}
//         </div>
//       )}

//       {/* Loading */}
//       {loading && !error && (
//         <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#6b7280', fontSize: 12 }}>
//           Connecting to Haivision Gateway…
//         </div>
//       )}

//       {/* Main content */}
//       {!loading && !error && (
//         <div style={{ flex: 1, overflow: 'hidden', position: 'relative' }}>

//           {/* Topology — always centred in full width */}
//           <div style={{
//             width: '100%', height: '100%', overflowY: 'auto',
//             display: 'flex', flexDirection: 'column',
//             alignItems: 'center', justifyContent: 'center',
//             padding: '28px 24px 24px',
//             transition: 'padding-right 0.3s ease',
//             paddingRight: selected ? (isFullscreen ? 420 : 24) : 24,
//           }}>
//             <div style={{ width: '100%', maxWidth: 700 }}>
//               <TopologyDiagram
//                 connections={connections}
//                 destAddress={destAddress}
//                 destName={routeName ?? channel.display_name ?? '—'}
//                 selectedIdx={selectedIdx}
//                 onSelect={i => setSelectedIdx(p => p === i ? null : i)}
//               />
//               {connections.length > 0 && selectedIdx == null && (
//                 <div style={{ textAlign: 'center', marginTop: 20, fontSize: 11, color: '#4b5563' }}>
//                   Click a client box to see detailed stats
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* Stats panel — slides in from right */}
//           <div style={{
//             position: 'absolute', top: 0, right: 0, bottom: 0,
//             width: isFullscreen ? 400 : '100%',
//             maxWidth: isFullscreen ? 400 : '100%',
//             background: '#0f1520',
//             borderLeft: '1px solid rgba(255,255,255,0.08)',
//             borderTop: isFullscreen ? 'none' : '1px solid rgba(255,255,255,0.08)',
//             overflowY: 'auto',
//             transform: selected
//               ? 'translateX(0)'
//               : isFullscreen ? 'translateX(100%)' : 'translateY(100%)',
//             transition: 'transform 0.3s cubic-bezier(0.4,0,0.2,1)',
//             zIndex: 10,
//             ...(isFullscreen ? {} : {
//               position: 'relative', transform: selected ? 'none' : 'none',
//               display: selected ? 'block' : 'none',
//             }),
//           }}>
//             {selected && (
//               <div style={{ padding: '20px 20px 28px' }}>
//                 {/* Header */}
//                 <div style={{
//                   display: 'flex', alignItems: 'center', justifyContent: 'space-between',
//                   marginBottom: 20,
//                 }}>
//                   <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
//                     <span style={{ width: 8, height: 8, borderRadius: '50%', flexShrink: 0,
//                       background: selected.state === 'connected' ? '#10b981' : '#ef4444',
//                       display: 'inline-block' }} />
//                     <span style={{ fontSize: 12, fontWeight: 600, color: '#fde047', fontFamily: 'monospace' }}>
//                       {selected.address}{selected.port && selected.port !== '—' ? `:${selected.port}` : ''}
//                     </span>
//                   </div>
//                   <button onClick={() => setSelectedIdx(null)} style={{
//                     background: 'rgba(255,255,255,0.06)', border: 'none',
//                     borderRadius: 4, width: 24, height: 24, cursor: 'pointer',
//                     color: '#9ca3af', fontSize: 14, display: 'flex',
//                     alignItems: 'center', justifyContent: 'center',
//                   }}>×</button>
//                 </div>

//                 {/* Stat grid */}
//                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
//                   <StatCell label="State"        value={selected.state}                           color={selected.state === 'connected' ? '#10b981' : '#ef4444'} />
//                   <StatCell label="Bitrate"      value={`${(selected.bitrate / 1000).toFixed(2)} Mbps`} color="#a78bfa" />
//                   <StatCell label="Used BW"      value={`${(selected.usedBandwidth / 1000).toFixed(2)} Mbps`} />
//                   <StatCell label="Sent Packets" value={selected.sentPackets?.toLocaleString()} />
//                   <StatCell label="RTT"          value={selected.rtt ? `${selected.rtt.toFixed(1)} ms` : '—'} />
//                   <StatCell label="Buffer"       value={selected.buffer ? `${selected.buffer} ms` : '—'} />
//                   <StatCell label="Latency"      value={selected.latency ? `${selected.latency} ms` : '—'} />
//                   <StatCell label="Path Redund." value={selected.pathRedundancy ?? 'None'} />
//                   <StatCell label="Dropped"      value={selected.droppedPackets}                color={selected.droppedPackets > 0 ? '#f87171' : '#10b981'} />
//                   <StatCell label="Lost Packets" value={selected.lostPackets?.toLocaleString()} />
//                   <StatCell label="Pkt Loss"     value={`${selected.pktLossRate ?? 0}%`}         color={(selected.pktLossRate ?? 0) > 0 ? '#f87171' : '#10b981'} />
//                   <StatCell label="Encryption"   value={selected.encryption ?? 'None'} />
//                   {/* <StatCell label="Mode"         value={selected.mode} />
//                   <StatCell label="Uptime"       value={selected.uptime} /> */}
//                 </div>
//               </div>
//             )}
//           </div>

//           {/* Hint when no caller selected */}
//           {connections.length > 0 && selectedIdx == null && (
//             <div style={{ textAlign: 'center', marginTop: 16, fontSize: 11, color: '#4b5563' }}>
//               Click a caller box to see detailed stats
//             </div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// }


import { useState, useEffect, useRef, useCallback } from 'react';

/**
 * HaivisionStatsTab
 * Shows a network topology diagram — caller boxes (yellow) connected
 * by dashed lines to the destination box (cyan) — matching the
 * Haivision Gateway UI style.
 * Click a caller box to expand its stats below the diagram.
 */

const REFRESH_OPTIONS = [2, 5, 10];
const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

function apiHeaders() {
  const token = sessionStorage.getItem('srt.auth.token');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

// ── Topology SVG — circular / radial layout ──────────────────────────────────
// Destination box at the CENTER. Client boxes arranged in a CIRCLE around it.
// Radius grows automatically as connection count increases.
function TopologyDiagram({ connections, destAddress, destName, selectedIdx, onSelect }) {
  const n = Math.max(connections.length, 0);

  // Scale box size down for many connections
  // Circular boxes — square dimensions with full border radius
  const BOX_W = n > 35 ? 100 : n > 20 ? 110 : n > 10 ? 120 : 130;
  const BOX_H = BOX_W;   // square → fully rounded = circle-like
  const DEST_W = 160;
  const DEST_H = 160;

  // Radius: enough arc between adjacent boxes so they don't overlap
  // arc per box = 2π r / n ≥ BOX_W + gap
  const MIN_R   = 160;
  const radius  = n < 2
    ? MIN_R
    : Math.max(MIN_R, Math.ceil(n * (BOX_W + 24) / (2 * Math.PI)));

  // Square SVG centred on (cx, cy)
  const PAD     = BOX_W + 30;
  const svgSize = 2 * (radius + PAD);
  const cx      = svgSize / 2;
  const cy      = svgSize / 2;

  // Client positions — evenly spaced around the circle, starting at top
  const clients = connections.map((conn, i) => {
    const angle = (2 * Math.PI * i / Math.max(n, 1)) - Math.PI / 2;
    return {
      conn,
      bx: cx + radius * Math.cos(angle) - BOX_W / 2,
      by: cy + radius * Math.sin(angle) - BOX_H / 2,
      cx: cx + radius * Math.cos(angle),
      cy: cy + radius * Math.sin(angle),
    };
  });

  const fontSize    = n > 30 ? 9  : n > 15 ? 10 : 11;
  const ipFontSize  = n > 30 ? 8  : n > 15 ?  9 : 10;

  return (
    <>
      <style>{`
        @keyframes dash-flow  { to { stroke-dashoffset: -40; } }
        @keyframes dest-pulse { 0%,100%{opacity:.15;r:${Math.round(radius * 0.18 + 20)}} 50%{opacity:.05;r:${Math.round(radius * 0.22 + 20)}} }
      `}</style>

      <svg
        viewBox={`0 0 ${svgSize} ${svgSize}`}
        style={{ width: '100%', display: 'block', margin: '0 auto' }}
      >
        <defs>
          <filter id="glow-ylw" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="2.5" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge>
          </filter>
          <filter id="glow-cyn" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="2" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge>
          </filter>
        </defs>

        {/* Pulsing ring around centre */}
        <circle cx={cx} cy={cy} r={radius * 0.18 + 20}
          fill="none" stroke="#eab308" strokeWidth="0.8"
          style={{ animation: `dest-pulse 3s ease-in-out infinite` }} />

        {/* Animated lines + packet dots FROM centre TO each client */}
        {clients.map(({ conn, cx: clx, cy: cly }, i) => {
          const pathD    = `M ${cx} ${cy} L ${clx} ${cly}`;
          const selected = selectedIdx === i;
          const d0 = ((i * 0.35) % 1.8).toFixed(2);
          const d1 = ((i * 0.35 + 0.6) % 1.8).toFixed(2);
          const d2 = ((i * 0.35 + 1.2) % 1.8).toFixed(2);
          return (
            <g key={`line-${i}`}>
              <path d={pathD} fill="none"
                stroke={selected ? '#22d3ee' : 'rgba(6,182,212,0.3)'}
                strokeWidth={selected ? 2 : 1.2}
                strokeDasharray="8 6"
                style={{ animation: `dash-flow ${selected ? 0.6 : 0.9}s linear infinite`, opacity: selected ? 0.9 : 0.45 }}
              />
              {[d0, d1, d2].map((d, pi) => (
                <circle key={pi} r={pi === 2 ? 2.5 : 3} fill="#eab308" filter="url(#glow-ylw)"
                  style={{ opacity: selected ? 1 : 0.65 }}>
                  <animateMotion dur="1.8s" repeatCount="indefinite" begin={`${d}s`} path={pathD} />
                </circle>
              ))}
            </g>
          );
        })}

        {/* ── CENTRE: Destination box (yellow) ── */}
        <rect x={cx - DEST_W / 2} y={cy - DEST_H / 2} width={DEST_W} height={DEST_H} rx={DEST_W / 2}
          fill="rgba(234,179,8,0.12)" stroke="#eab308" strokeWidth="2" />
        <text x={cx} y={cy - 18}
          fontSize="13" fontWeight="700" fill="#fde047" fontFamily="Arial, sans-serif"
          textAnchor="middle" dominantBaseline="central">
          {destName.length > 14 ? destName.slice(0, 14) + '…' : destName}
        </text>
        <text x={cx} y={cy + 4}
          fontSize="8" fill="#ca8a04" fontFamily="'Courier New', monospace"
          textAnchor="middle" dominantBaseline="central">
          {destAddress.length > 20 ? destAddress.slice(0, 20) + '…' : destAddress}
        </text>
        <text x={cx} y={cy + 22}
          fontSize="9" fontWeight="600" fill="#92400e" fontFamily="monospace"
          textAnchor="middle" dominantBaseline="central">
          {`${connections.length} CLIENT${connections.length !== 1 ? 'S' : ''}`}
        </text>

        {/* ── CIRCLE: Client boxes (cyan) ── */}
        {clients.map(({ conn, bx, by, cx: clx, cy: cly }, i) => {
          const sel    = selectedIdx === i;
          const isConn = conn.state === 'connected' || conn.state === 'Connected';
          const ip     = conn.port && conn.port !== '—'
            ? `${conn.address}:${conn.port}` : conn.address;
          const ipShort = ip.length > 20 ? ip.slice(0, 20) + '…' : ip;
          return (
            <g key={`client-${i}`} onClick={() => onSelect(i)} style={{ cursor: 'pointer' }}>
              {sel && (
                <circle cx={bx + BOX_W/2} cy={by + BOX_H/2} r={BOX_W/2 + 4}
                  fill="none" stroke="#22d3ee" strokeWidth="1.5" opacity="0.4" />
              )}
              <circle cx={bx + BOX_W/2} cy={by + BOX_H/2} r={BOX_W/2}
                fill={sel ? 'rgba(6,182,212,0.18)' : 'rgba(6,182,212,0.07)'}
                stroke={sel ? '#22d3ee' : '#0e7490'} strokeWidth={sel ? 2 : 1.2} />
              <circle cx={bx + BOX_W/2} cy={by + BOX_H * 0.28} r={4}
                fill={isConn ? '#10b981' : '#ef4444'} filter={isConn ? 'url(#glow-cyn)' : 'none'} />
              <text x={bx + BOX_W/2} y={by + BOX_H * 0.48}
                fontSize={fontSize} fontWeight="700" fill="#22d3ee" fontFamily="Arial, sans-serif"
                textAnchor="middle" dominantBaseline="central">
                {`C${i + 1}`}
              </text>
              <text x={bx + BOX_W/2} y={by + BOX_H * 0.66}
                fontSize={ipFontSize - 1} fill="#0891b2" fontFamily="'Courier New', monospace"
                textAnchor="middle" dominantBaseline="central">
                {conn.address.length > 13 ? conn.address.slice(0, 13) + '…' : conn.address}
              </text>
              {conn.bitrate > 0 && (
                <text x={bx + BOX_W/2} y={by + BOX_H * 0.82}
                  fontSize={ipFontSize - 1} fill="#155e75" textAnchor="middle" fontFamily="monospace"
                  dominantBaseline="central">
                  {(conn.bitrate / 1000).toFixed(1)}M
                </text>
              )}
            </g>
          );
        })}

        {/* Empty state */}
        {n === 0 && (
          <text x={cx} y={cy + 80} textAnchor="middle" fontSize="12" fill="#6b7280">
            No active connections
          </text>
        )}
      </svg>
    </>
  );
}


function StatCell({ label, value, color }) {
  return (
    <div style={{ padding: '8px 12px', background: 'rgba(255,255,255,0.04)', borderRadius: 6 }}>
      <div style={{ fontSize: 9, color: '#6b7280', marginBottom: 3, letterSpacing: '0.04em' }}>
        {label}
      </div>
      <div style={{ fontSize: 13, fontFamily: 'monospace', color: color ?? '#e5e7eb', fontWeight: 600 }}>
        {value ?? '—'}
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// Main
// ─────────────────────────────────────────────────────────────────────────────
export default function HaivisionStatsTab({ channel }) {
  const [refreshSec,  setRefreshSec]  = useState(2);
  const [routeId,     setRouteId]     = useState(null);
  const [routeName,   setRouteName]   = useState(null);
  const [connections, setConnections] = useState([]);
  const [routeState,  setRouteState]  = useState(null);
  const [selectedIdx, setSelectedIdx] = useState(null);
  const [destAddr,    setDestAddr]    = useState(null);
  const [error,       setError]       = useState(null);
  const [loading,     setLoading]     = useState(true);
  const timerRef     = useRef(null);
  const [isFullscreen, setIsFullscreen] = useState(false);

  // Close fullscreen on Escape key
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape' && isFullscreen) setIsFullscreen(false); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [isFullscreen]);

  function toggleFullscreen() {
    setIsFullscreen(f => !f);
  }

  // Step 1: find matching route
  useEffect(() => {
    let cancelled = false;
    async function findRoute() {
      try {
        const res = await fetch(`${API_BASE}/haivision/routes`, { headers: apiHeaders() });
        if (!res.ok) {
          const text = await res.text();
          throw new Error(
            res.status === 502 ? 'Cannot reach Haivision. Check HAIVISION_URL in .env'
            : res.status === 401 ? 'Not authenticated — open SRT Manager through DR Pulse 360'
            : `Routes error: ${res.status}`
          );
        }
        const routes = await res.json();
        if (!Array.isArray(routes) || routes.length === 0) {
          throw new Error('No routes returned from Haivision');
        }

        const cName = (channel.display_name ?? '').toLowerCase();
        const ip    = channel.channel_ip ?? '';

        const match = routes.find(r => {
          const rName = (r.name ?? '').toLowerCase();
          return rName.includes(cName) || cName.includes(rName)
            || (ip && JSON.stringify(r).includes(ip));
        }) ?? routes[0];

        if (!cancelled) {
          setRouteId(match.id ?? match.routeId);
          setRouteName(match.name ?? channel.display_name);
        }
      } catch (e) {
        if (!cancelled) { setError(e.message); setLoading(false); }
      }
    }
    findRoute();
    return () => { cancelled = true; };
  }, [channel.channel_ip, channel.display_name]);

  // Step 2: poll stats
  const fetchStats = useCallback(async () => {
    if (!routeId) return;
    try {
      const res = await fetch(
        `${API_BASE}/haivision/routes/${routeId}/stats`,
        { headers: apiHeaders() }
      );
      if (!res.ok) throw new Error(`Stats error: ${res.status}`);
      const data = await res.json();
      setConnections(data.connections ?? []);
      setRouteState(data.state ?? null);
      if (data.destAddress && data.destAddress !== '—') {
        setDestAddr(data.destAddress);
      }
      setError(null);
      setLoading(false);
    } catch (e) {
      setError(e.message);
      setLoading(false);
    }
  }, [routeId]);

  useEffect(() => {
    if (!routeId) return;
    fetchStats();
    timerRef.current = setInterval(fetchStats, refreshSec * 1000);
    return () => clearInterval(timerRef.current);
  }, [fetchStats, refreshSec, routeId]);

  const selected = selectedIdx != null ? connections[selectedIdx] : null;
  const destAddress = destAddr
    ?? (channel.channel_ip
      ? `${channel.channel_ip}${channel.source_port ? ':' + channel.source_port : ''}`
      : '—');

  return (
    <div style={{
      display: 'flex', flexDirection: 'column',
      background: '#0d1117', color: '#f3f4f6',
      overflow: 'hidden',
      ...(isFullscreen ? {
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        zIndex: 99999, width: '100vw', height: '100vh', borderRadius: 0,
      } : {
        height: '100%', minHeight: 440, borderRadius: '0 0 10px 10px',
      }),
    }}>

      {/* Toolbar */}
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '8px 16px', background: '#161b22',
        borderBottom: '1px solid rgba(255,255,255,0.08)', flexShrink: 0,
      }}>
        <div style={{ fontSize: 11, fontWeight: 600, color: '#94a3b8' }}>
          {routeName
            ? `${connections.length} connection${connections.length !== 1 ? 's' : ''} · ${routeName}`
            : 'Connecting to Haivision…'}
          {routeState && (
            <span style={{
              marginLeft: 10, fontSize: 9, padding: '2px 7px', borderRadius: 3,
              background: routeState === 'running' ? 'rgba(16,185,129,0.15)' : 'rgba(100,100,100,0.15)',
              color: routeState === 'running' ? '#10b981' : '#6b7280',
            }}>
              {routeState.toUpperCase()}
            </span>
          )}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <span style={{ fontSize: 9, color: '#6b7280' }}>Refresh</span>
          <div style={{ display: 'flex', background: '#1f2937', borderRadius: 4, overflow: 'hidden' }}>
            {REFRESH_OPTIONS.map(s => (
              <button key={s} onClick={() => setRefreshSec(s)} style={{
                padding: '3px 8px', fontSize: 9, border: 'none', cursor: 'pointer',
                background: refreshSec === s ? '#4f46e5' : 'transparent',
                color: refreshSec === s ? '#fff' : '#9ca3af', fontFamily: 'monospace',
              }}>{s}s</button>
            ))}
          </div>
          <button
            onClick={toggleFullscreen}
            title={isFullscreen ? 'Exit fullscreen' : 'Fullscreen'}
            style={{
              background: 'none', border: '1px solid rgba(255,255,255,0.15)',
              borderRadius: 4, padding: '3px 8px', cursor: 'pointer',
              color: '#9ca3af', fontSize: 12, lineHeight: 1,
              display: 'flex', alignItems: 'center', gap: 4,
            }}
          >
            {isFullscreen ? (
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M4.5 1.5H2a.5.5 0 0 0-.5.5v2.5M7.5 1.5H10a.5.5 0 0 1 .5.5v2.5M4.5 10.5H2a.5.5 0 0 1-.5-.5V7.5M7.5 10.5H10a.5.5 0 0 0 .5-.5V7.5"/>
              </svg>
            ) : (
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M1.5 4.5V2a.5.5 0 0 1 .5-.5h2.5M7.5 1.5H10a.5.5 0 0 1 .5.5v2.5M10.5 7.5V10a.5.5 0 0 1-.5.5H7.5M4.5 10.5H2a.5.5 0 0 1-.5-.5V7.5"/>
              </svg>
            )}
          </button>
        </div>
      </div>

      {/* Error */}
      {error && (
        <div style={{
          padding: '10px 16px', background: 'rgba(239,68,68,0.1)',
          borderBottom: '1px solid rgba(239,68,68,0.2)', fontSize: 11, color: '#f87171', flexShrink: 0,
        }}>
          {error}
        </div>
      )}

      {/* Loading */}
      {loading && !error && (
        <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#6b7280', fontSize: 12 }}>
          Connecting to Haivision Gateway…
        </div>
      )}

      {/* Main content */}
      {!loading && !error && (
        <div style={{ flex: 1, overflow: 'hidden', position: 'relative' }}>

          {/* Topology — always centred in full width */}
          <div style={{
            width: '100%', height: '100%', overflowY: 'auto',
            display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center',
            padding: '28px 24px 24px',
            transition: 'padding-right 0.3s ease',
            paddingRight: selected ? (isFullscreen ? 420 : 24) : 24,
          }}>
            <div style={{ width: '100%', maxWidth: 700 }}>
              <TopologyDiagram
                connections={connections}
                destAddress={destAddress}
                destName={routeName ?? channel.display_name ?? '—'}
                selectedIdx={selectedIdx}
                onSelect={i => setSelectedIdx(p => p === i ? null : i)}
              />
              {connections.length > 0 && selectedIdx == null && (
                <div style={{ textAlign: 'center', marginTop: 20, fontSize: 11, color: '#4b5563' }}>
                  Click a client box to see detailed stats
                </div>
              )}
            </div>
          </div>

          {/* Stats panel — slides in from right */}
          <div style={{
            position: 'absolute', top: 0, right: 0, bottom: 0,
            width: isFullscreen ? 400 : '100%',
            maxWidth: isFullscreen ? 400 : '100%',
            background: '#0f1520',
            borderLeft: '1px solid rgba(255,255,255,0.08)',
            borderTop: isFullscreen ? 'none' : '1px solid rgba(255,255,255,0.08)',
            overflowY: 'auto',
            transform: selected
              ? 'translateX(0)'
              : isFullscreen ? 'translateX(100%)' : 'translateY(100%)',
            transition: 'transform 0.3s cubic-bezier(0.4,0,0.2,1)',
            zIndex: 10,
            ...(isFullscreen ? {} : {
              position: 'relative', transform: selected ? 'none' : 'none',
              display: selected ? 'block' : 'none',
            }),
          }}>
            {selected && (
              <div style={{ padding: '20px 20px 28px' }}>
                {/* Header */}
                <div style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  marginBottom: 20,
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span style={{ width: 8, height: 8, borderRadius: '50%', flexShrink: 0,
                      background: selected.state === 'connected' ? '#10b981' : '#ef4444',
                      display: 'inline-block' }} />
                    <span style={{ fontSize: 12, fontWeight: 600, color: '#fde047', fontFamily: 'monospace' }}>
                      {selected.address}{selected.port && selected.port !== '—' ? `:${selected.port}` : ''}
                    </span>
                  </div>
                  <button onClick={() => setSelectedIdx(null)} style={{
                    background: 'rgba(255,255,255,0.06)', border: 'none',
                    borderRadius: 4, width: 24, height: 24, cursor: 'pointer',
                    color: '#9ca3af', fontSize: 14, display: 'flex',
                    alignItems: 'center', justifyContent: 'center',
                  }}>×</button>
                </div>

                {/* Stat grid */}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                  <StatCell label="State"        value={selected.state}                           color={selected.state === 'connected' ? '#10b981' : '#ef4444'} />
                  <StatCell label="Bitrate"      value={`${(selected.bitrate / 1000).toFixed(2)} Mbps`} color="#a78bfa" />
                  <StatCell label="Used BW"      value={`${(selected.usedBandwidth / 1000).toFixed(2)} Mbps`} />
                  <StatCell label="Sent Packets" value={selected.sentPackets?.toLocaleString()} />
                  <StatCell label="RTT"          value={selected.rtt ? `${selected.rtt.toFixed(1)} ms` : '—'} />
                  <StatCell label="Buffer"       value={selected.buffer ? `${selected.buffer} ms` : '—'} />
                  <StatCell label="Latency"      value={selected.latency ? `${selected.latency} ms` : '—'} />
                  <StatCell label="Path Redund." value={selected.pathRedundancy ?? 'None'} />
                  <StatCell label="Dropped"      value={selected.droppedPackets}                color={selected.droppedPackets > 0 ? '#f87171' : '#10b981'} />
                  <StatCell label="Lost Packets" value={selected.lostPackets?.toLocaleString()} />
                  <StatCell label="Pkt Loss"     value={`${selected.pktLossRate ?? 0}%`}         color={(selected.pktLossRate ?? 0) > 0 ? '#f87171' : '#10b981'} />
                  <StatCell label="Encryption"   value={selected.encryption ?? 'None'} />
                  <StatCell label="Mode"         value={selected.mode} />
                  <StatCell label="Uptime"       value={selected.uptime} />
                </div>
              </div>
            )}
          </div>

          {/* Hint when no caller selected */}
          {connections.length > 0 && selectedIdx == null && (
            <div style={{ textAlign: 'center', marginTop: 16, fontSize: 11, color: '#4b5563' }}>
              Click a caller box to see detailed stats
            </div>
          )}
        </div>
      )}
    </div>
  );
}